import { ref } from 'vue';

import type { ApiResponse, UserItem } from '@/shared/lib';

import { fetchAllMembersAsCollaborators } from './memberSelection';

export interface FetchAllMembersOptions {
  includeInactiveMembers?: boolean;
}

export function useFetchMembers() {
  const members = ref<ApiResponse<UserItem[]>>({ success: false, data: [] });

  const fetchAllMembers = async (branchId?: number, options: FetchAllMembersOptions = {}) => {
    const { includeInactiveMembers = true } = options;
    try {
      const data = await fetchAllMembersAsCollaborators(
        branchId,
        includeInactiveMembers ? { includeInactiveMembers: true } : undefined
      );
      members.value = {
        success: true,
        data,
      };
    } catch (error) {
      console.error('Error fetching members:', error);
      members.value = { success: false, message: 'Failed to fetch members', data: [] };
    }
  };

  return {
    members,
    fetchAllMembers,
  };
}
